const avatars = [
	{ url: '/images/male-1.png', gender: 'male', id: 'male1' },
	{ url: '/images/male-2.png', gender: 'male', id: 'male2' },
	{ url: '/images/male-3.png', gender: 'male', id: 'male3' },
	{ url: '/images/female-1.png', gender: 'female', id: 'female1' },
	{ url: '/images/female-2.png', gender: 'female', id: 'female2' },
	{ url: '/images/female-3.png', gender: 'female', id: 'female3' }
];

export default avatars;
